export class ModeloDownloadAnexo {
  id: number;
  idAnexo: number;
  descricao: string;
  arquivo: string;
  statusExc: boolean;
  dataHoraExc?: Date;
  nomeUsuarioExc: string;
}
